/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { ixmUserauthV1RealmAccessTokenServiceGetRealmAccessToken } from '@interxfi/api-client/generated/client-functions/ixm-userauth-v1-realm-access-token-service-get-realm-access-token';
import type { IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenGetRealmAccessTokenRequest, IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenResponse } from '@interxfi/types';
import { type DefinedInitialDataOptions, queryOptions, useQuery } from '@tanstack/react-query';
import { useRealmAuthIsAuthenticated } from '../../context';

/**
 * @generated by NormalizedQueryPlugin (get /portal/userauth/v1/realm_access/:realmAccessId/token) */

export function buildIxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenKey(request?: IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenGetRealmAccessTokenRequest) { return ['ixmUserauthV1RealmAccessTokenServiceGetRealmAccessToken', 'detail', request] as const; }

export function buildIxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenQueryOptions(isAuthenticated: boolean, request: IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenGetRealmAccessTokenRequest | undefined, options?: Partial<DefinedInitialDataOptions<IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenResponse | undefined>>) { return queryOptions({
    queryKey: buildIxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenKey(request),
    queryFn: async () => ixmUserauthV1RealmAccessTokenServiceGetRealmAccessToken('', request),
    enabled: Boolean(isAuthenticated && request?.realmAccessId),
    ...options
}); }

export function useIxmUserauthV1RealmAccessTokenServiceGetRealmAccessToken(request: IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenGetRealmAccessTokenRequest | undefined, options?: Partial<DefinedInitialDataOptions<IxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenResponse | undefined>>) {
    const isAuthenticated = useRealmAuthIsAuthenticated();
    
    return useQuery(buildIxmUserauthV1RealmAccessTokenServiceGetRealmAccessTokenQueryOptions(isAuthenticated, request, options));
}
